import { render } from "./WaitingForPicture.vue?vue&type=template&id=15cd6e4d&ts=true"
import script from "./WaitingForPicture.vue?vue&type=script&lang=ts"
export * from "./WaitingForPicture.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__